import React from "react"
import { useState } from "react"
export default function LeftMenu () {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
      
      // Хардкодное меню
      const menuItems = [
        {
          title: 'Основные сведения',
          url: '/page/osnovnye-svedeniya-0',
        },
        {
          title: 'Структура и органы управления',
          url: '/sveden/struct',
        },
        {
          title: 'Документы',
          url: '/sveden/document',
        },
        {
          title: 'Образование',
          url: '/sveden/education',
        },
        {
          title: 'Образовательные стандарты и требования',
          url: '/sveden/eduStandarts',
        },
        {
          title: 'Руководство',
          url: '/sveden/managers',
        },
        {
          title: 'Педагогический состав',
          url: '/sveden/employees',
        },
        {
          title: 'Материально-техническое обеспечение и оснащённость образовательного процесса',
          url: '/sveden/objects',
        },
        {
          title: 'Платные образовательные услуги',
          url: '/sveden/paid_edu',
        },
        {
          title: 'Финансово-хозяйственная деятельность',
          url: '/sveden/budget',
        },
        {
          title: 'Вакантные места для приёма обучающихся',
          url: '/sveden/vacant',
        },
        {
          title: 'Стипендии и меры поддержки обучающихся',
          url: '/sveden/grants',
        },
        {
          title: 'Международное сотрудничество',
          url: '/sveden/inter',
          subItems: [
            { title: 'Студентам НГЛУ', url: '/page/studentam-nglu-outgoing-students' },
            { title: 'Для приезжающих студентов', url: '/page/incoming-students' },
            { title: 'ВУЗы-партнеры', url: '/page/vuzy-partnery' },
            { title: 'SDI Munchen Germany Erasmus+KA 107 International Credit Mobility', url: '/page/sdi-munchen-germany-erasmuska-107-international-credit-mobility' },
            { title: 'Международные мероприятия', url: '/page/mezhdunarodnye-meropriyatiya' },
            { title: 'Отзывы студентов', url: '/page/otzyvy-studentov' },
            { title: 'Проживание', url: '/page/prozhivanie' },
            { title: 'Информация для приезжающих студентов в РФ во время пандемии коронавируса COVID-19', url: '/page/informaciya-dlya-priezzhayushchih-studentov-v-rf-vo-vremya-pandemii-koronavirusa-covid-19' },
            { title: 'Контакты Управления по международной деятельности', url: '/page/kontakty-upravleniya-po-mezhdunarodnoy-deyatelnosti' },
          ]
        },
        {
          title: 'Организация питания в образовательной организации',
          url: '/sveden/catering',
        },
        {
          title: 'Комплексная безопасность университета',
          url: '/page/kompleksnaya-bezopasnost-universiteta',
        },
        {
          title: 'Замещение должностей научно-педагогических работников',
          url: '/page/zameshchenie-dolzhnostey-nauchno-pedagogicheskih-rabotnikov',
        },
        {
          title: 'Информационные ресурсы',
          url: '/page/informacionnye-resursy',
          subItems: [
            { title: 'Сотрудникам', 
              url: '/page/sotrudnikam',
              subItems: [
                { title: 'E-Learning', url: '/page/e-learning' },
                { title: 'Медиатека', url: '/page/mediateka' },
                { title: 'Разработчикам массовых открытых онлайн курсов', url: '/page/razrabotchikam-massovyh-otkrytyh-onlayn-kursov' },
              ]
             },
            { title: 'Абитуриентам', url: '/page/abiturientam' },
            { title: 'Студентам', 
              url: '/page/studentam',
              subItems: [
                { title: 'ELearning', url: '/page/elearning' },
                { title: 'Стать частью команды Digital Lab', url: '/page/stat-chastyu-komandy-digital-lab' },
                { title: 'Медиатека', url: '/page/mediateka-0' },
              ] 
            },
          ]
        },
        {
          title: 'Ученый совет НГЛУ',
          url: '/page/uchenyy-sovet-nglu',
        },
        {
          title: 'Почетные профессора НГЛУ',
          url: '/page/pochetnye-professora-nglu',
        },
        {
          title: 'Студенческий совет НГЛУ',
          url: '/page/studencheskiy-sovet-nglu',
        },
        {
          title: 'Сектор контроля качества образования',
          url: '/page/sektor-kontrolya-kachestva-obrazovaniya',
          subItems: [
            { title: 'Основные сведения', url: '/page/osnovnye-svedeniya' },
            { title: 'Независимая оценка качества деятельности', url: '/page/nezavisimaya-ocenka-kachestva-deyatelnosti' },
            { title: 'Рейтинг деятельности студентов', url: '/page/reyting-deyatelnosti-studentov' },
            { title: 'Информация для научно-педагогических работников', url: '/page/informaciya-dlya-nauchno-pedagogicheskih-rabotnikov' },
            { title: 'Международная профессионально-общественная аккредитация', url: '/page/mezhdunarodnaya-professionalno-obshchestvennaya-akkreditaciya' }
          ]
        }
      ]
    
      // Функция для отображения пунктов меню
      const renderMenuItems = (items, depth = 0) => {
        return (
          <ul style={{ 
            listStyle: 'none', 
            paddingLeft: depth > 0 ? '20px' : '0',
            margin: depth > 0 ? '5px 0' : '10px 0'
          }}>
            {items.map((item, index) => (
              <li key={index} style={{ marginBottom: '8px'}}>
                <a 
                  href={item.url} 
                  style={{
                    color: depth === 0 ? '#1a3e72' : '#333',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '8px 15px',
                    borderRadius: '4px',
                    fontWeight: depth === 0 ? '600' : 'normal',
                    fontSize: depth === 0 ? '16px' : '14px',
                    transition: 'all 0.3s ease',
                    backgroundColor: 'transparent',
                    borderLeft: depth > 1 ? '3px solid #ddd' : 'none',
                    ':hover': {
                      backgroundColor: '#f5f7fa',
                      color: depth === 0 ? '#0d2b5e' : '#222'
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f5f7fa';
                    e.currentTarget.style.color = depth === 0 ? '#0d2b5e' : '#222';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = depth === 0 ? '#1a3e72' : '#333';
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.title}
                  {item.subItems && (
                    <span style={{ 
                      float: 'right',
                      transition: 'transform 0.3s',
                      transform: 'rotate(0deg)'
                    }}>›</span>
                  )}
                </a>
                {item.subItems && item.subItems.length > 0 && renderMenuItems(item.subItems, depth + 1)}
              </li>
            ))}
          </ul>
        )
      }
      return(<>
      {/* Бургер-меню */}
      {!isMenuOpen && typeof window !== 'undefined' && 
        (window.location.pathname === '/sveden/eduStandarts' ||
        window.location.pathname === '/sveden/catering' ||
        window.location.pathname === '/sveden/inter' ||
        window.location.pathname === '/sveden/grants' ||
        window.location.pathname === '/sveden/vacant' ||
        window.location.pathname === '/sveden/budget' ||
        window.location.pathname === '/sveden/paid_edu' ||
        window.location.pathname === '/sveden/objects' ||
        window.location.pathname === '/sveden/employees' ||
        window.location.pathname === '/sveden/managers' ||
        window.location.pathname === '/sveden/education' ||
        window.location.pathname === '/sveden/document' ||
        window.location.pathname === '/sveden/struct' ||
        window.location.pathname === '/page/osnovnye-svedeniya-0') &&  (
  <div 
    style={{
      width: '30px', 
      position: 'fixed', 
      left: '10px',
      top: '50%', // Центрируем по вертикали
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      zIndex: 1000,
      padding: '10px',
      backgroundColor: 'transparent',
      borderRadius: '4px'
    }}
    onClick={() => setIsMenuOpen(true)}
  >
    <svg viewBox="0 0 24 24" width="24" height="24">
      <rect x="3" y="5" width="18" height="2" fill="#333" />
      <rect x="3" y="11" width="18" height="2" fill="#333" />
      <rect x="3" y="17" width="18" height="2" fill="#333" />
    </svg>
  </div>
)}

{/* Само меню */}
{isMenuOpen && (
  <div 
    style={{
      position: 'fixed',
      left: '0',
      top: '0',
      width: '280px',
      height: '100vh',
      backgroundColor: '#fff',
      boxShadow: '2px 0 10px rgba(0,0,0,0.2)',
      zIndex: 999,
      padding: '60px 20px 20px',
      overflowY: 'auto',
      transition: 'transform 0.3s ease-out',
      transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)'
    }}
  >
    {/* Кнопка закрытия (крестик) */}
    <button 
      onClick={() => setIsMenuOpen(false)}
      style={{
        position: 'absolute',
        right: '15px',
        top: '15px',
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#666',
        ':hover': {
          color: '#000'
        }
      }}
    >
      ×
    </button>
        <h4 style={{ 
            margin: '0 0 20px 10px',
            paddingBottom: '10px',
            borderBottom: '1px solid #eee'
        }}>
            Сведения об образовательной организации
        </h4>
            {renderMenuItems(menuItems)}
          </div>
        )}
        
        {/* Затемнение фона при открытом меню */}
        {isMenuOpen && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 998,
              cursor: 'pointer',
            }}
            onClick={() => setIsMenuOpen(false)}
          />
        )}
        </>
    )
}